module.exports = __webpack_public_path__ + "static/img/Essendon.a07456e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Essendon.jpg
// module id = a9N2
// module chunks = 1